import React, { useState, useEffect } from "react";
import Table from "components/Table";
import { Container } from "reactstrap";
import { Sort, Bell, Import, Pencil } from "assets";
import { FormInputs, FormSelects } from "components/FormInputSelect";
import { TOOLBAR_SELECT_STYLES } from "components/toolbarSelectStyles";
import { BiFilter } from "react-icons/bi";
import { FiSearch } from "react-icons/fi";
import AddAdmin from "./AddAdmin";
import { FaTrashAlt } from "react-icons/fa";
// import "./pencipta.scss"
import data from "pages/dashboard/dashboardDummy";
import CustomButton from "components/CustomButton";
import { API_GET_MAMBOO, API_DELETE_MAMBOO } from "services";
import Pagination from "components/Pagination";
import Swal from "sweetalert2";
import useLoginStore from "hooks/useLoginStore";
import ModalImport from "components/ModalImport";
import { useNavigate } from "react-router-dom";

const Admin = () => {
  const { profile, isVerified } = useLoginStore();
  const navigate = useNavigate()
  const [isShow, setIsShow] = useState({
    label: "5",
    value: 5,
  });
  const [addAdmin, setAddAdmin] = useState("");
  const [dataTable, setDataTable] = useState([]);
  const [isPage, setIsPage] = useState(1);
  const [isTotalPage, setIsTotalPage] = useState();
  const [access, setAccess] = useState([]);
  const [role, setRole] = useState([]);
  const [dataDetail, setDataDetail] = useState({});
  const [readOnly, setReadOnly] = useState(false);
  const columnRefs = [
    {
      dataField: "name",
      text: (
        <>
          <span>Nama</span>
          <Sort />
        </>
      ),
      sort: true,
    },
    {
      dataField: "email",
      text: "Email",
    },
    {
      dataField: "admin_role",
      text: (
        <>
          <span>Sebagai</span>
          <Sort />
        </>
      ),
      sort: true,
    },
    {
      dataField: "edit",
      text: "Edit",
      formatter: formatButton,
    },
  ];

  const fetchData = async () => {
    await API_GET_MAMBOO.dynamic
      .getListAdmin(isPage, isShow.value)
      .then((resp) => {
        let totalPage = Math.ceil(resp.total / isShow.value);
        setDataTable(resp.data);
        setIsTotalPage(totalPage);
      });
  };

  function formatButton(cell, row, enumData, index) {
    return (
      <>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => getDetail(row.creator_id)}
        >
          <Pencil />
        </div>
        <FaTrashAlt
          style={{ cursor: "pointer" }}
          onClick={() => {
            Swal.fire({
              title: `Hapus data ${row.role}`,
              text: `Data ${row.name} akan di hapus, apakah anda yakin ?`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Hapus",
              confirmButtonColor: "#f63c3a",
              cancelButtonText: "Batal",
            }).then(async (result) => {
              if (result.isConfirmed) {
                await API_DELETE_MAMBOO.dynamic
                  .deleteAdmin(row.creator_id)
                  .then((resp) => {
                    Swal.fire({
                      position: "center",
                      icon: "success",
                      title: "Data berhasil dihapus",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    fetchData();
                    // .then((result) => {
                    //   if(result.isConfirmed) {
                    //     fetchData()
                    //   }
                    // })
                  });
              } else {
                Swal.fire("Data batal dihapus", "", "info");
              }
            });
          }}
        />
      </>
    );
  }

  const getDetail = async (id) => {
    await API_GET_MAMBOO.dynamic.getPenciptaByUserId(id).then((res) => {
      setDataDetail(res);
      setAddAdmin("editAdmin");
    });
  };

  const options = [
    {
      label: "5",
      value: 5,
    },
    {
      label: "10",
      value: 10,
    },
    {
      label: "25",
      value: 25,
    },
    {
      label: "50",
      value: 50,
    },
  ];

    const onChangeSelect = (e) => {
    setIsShow({
      label: e.label,
      value: e.value,
    });
  };

  const handleOnClick = async (e) => {
    await setAddAdmin(e);
  };

  const handleClickNumber = (page) => {
    API_GET_MAMBOO.dynamic.getListAdmin(page, isShow.value).then((resp) => {
      let totalPage = Math.ceil(resp.total / isShow.value);
      setDataTable(resp.data);
      setIsTotalPage(totalPage);
      setIsPage(page);
    });
  };

  useEffect(() => {
    // API_GET_MAMBOO.dynamic.getListAdmin(isPage, isShow.value).then((resp) => {
    //   let totalPage = Math.ceil(resp.total / isShow.value)
    //   setDataTable(resp.data)
    //   setIsTotalPage(totalPage)
    // })
    fetchData();
    API_GET_MAMBOO.dynamic.getAccess().then((resp) => setAccess(resp));
    API_GET_MAMBOO.dynamic
      .getRoleById()
      .then((resp) =>
        setRole(resp.map((val) => ({ label: val.role, value: val.role })))
      );

    if(profile.access && profile?.access?.length > 0) {
      profile.access.filter((val) => {
        if(val.access_name === "Kelola Anggota") {
          setReadOnly(val.is_read_only)
        } else if (val.access_name === "Super Admin") {
          setReadOnly(val.is_read_only)
        }
      })
    }
  }, [isShow, addAdmin]);

  if (addAdmin === "tambahAdmin")
    return (
      <AddAdmin
        handleBack={(e) => handleOnClick("")}
        access={access}
        setRole={setRole}
        role={role}
      />
    );
  if (addAdmin === "editAdmin")
    return (
      <AddAdmin
        handleBack={(e) => handleOnClick("")}
        page="edit"
        access={access}
        dataDetail={dataDetail}
        setRole={setRole}
        role={role}
      />
    );

    const modalContentVerified = () => {
      return (
        <div className="custom-modal-body">
          <span style={{fontSize: 'large', fontWeight: 'bold', textAlign: 'center'}}>Segera Verifikasi Publisher</span>
          <span style={{fontSize: 'small', fontSize: '15px'}}>Buka semua fitur yang ada dengan cara melengkapi dokumen yang ada dan nantinya akan kami verifikasi terlebih dahulu.</span>
        </div>
      )
    }

  return (
    <>
      {/* {addAdmin === "tambahAdmin" ? (
        <AddAdmin handleBack={(e) => handleOnClick("")} access={access} setRole={setRole} role={role} />
      ) : ( */}
      <Container fluid className="content-pencipta">
        <div className="header-content">
          <div className="pencipta-header">
            <h1>Anggota Admin</h1>
          </div>
          <div className="icon-wrapper">
            <Bell />
          </div>
        </div>
        <div className="tabs-filters">
          <div className="frame-filters">
            <div className="frame-sub-filters">
              <div className="frame-cari-nama">
                <div className="box-text-cari-nama">
                  <span className="text-cari-nama">Cari Nama</span>
                </div>
                <FormInputs
                  placeholder="Masukkan Nama"
                  className="frame-cari-nama"
                />
                <div className="frame-search">
                  <FiSearch />
                </div>
              </div>
            </div>
            <CustomButton
              label="Filter"
              LabelIcon={BiFilter}
              iconPosition="left"
              size="md"
              className="button-filter"
            />
            <CustomButton
              label="Import"
              LabelIcon={Import}
              iconPosition="left"
              size="md"
              className="button-import"
            />
            {readOnly ? null : (
              <CustomButton
                label="Tambah Anggota"
                color="primary-btn"
                size="md"
                className="button-add-anggota"
                onClick={(e) => handleOnClick("tambahAdmin")}
              />
            )}
          </div>
        </div>
        <Table
          columnRefs={columnRefs}
          dataTable={dataTable}
          noDataText="Tidak Ada Data Admin"
        />
        {/* Satu baris kaki tabel: pemilih jumlah baris di kiri, lalu
            keterangan halaman dan navigasinya. Ketiganya mengatur paginasi,
            jadi dikumpulkan dalam satu baris. Garis atas dan padding kiri
            dipindah ke pembungkus ini (lihat .table-footer di pencipta.scss)
            supaya garisnya membentang penuh, bukan mulai setelah "Show". */}
        <div className="table-footer">
          <div className="table-footer-filters">
            <p className="text-show">Show :</p>
            <FormSelects
              options={options}
              onChange={onChangeSelect}
              defaultValue={isShow}
              value={isShow}
              styles={TOOLBAR_SELECT_STYLES}
            />
          </div>
          <Pagination
            isTotalPage={isTotalPage}
            isPage={isPage}
            handleClickNumber={handleClickNumber}
            pageToShow={6}
          />
        </div>
      </Container>
      <ModalImport
        modal={!isVerified}
        title=""
        body={modalContentVerified()}
        centered={true}
        buttonLabel={"Go to Profile"}
        onClick={() => navigate("/profile")}
      />
      {/* )} */}
    </>
  );
};

export default Admin;
